export const StatusChip = {
  tag: 'span',
  padding: 'Y Z',
  borderRadius: 'Z',
  fontSize: 'Y',
  fontWeight: '600',
}

export const StatusConfirmed = {
  extends: 'StatusChip',
  background: 'greenBg',
  color: 'green',
  border: '1px solid greenBorder',
}

export const StatusPending = {
  extends: 'StatusChip',
  background: 'amberBg',
  color: 'amber',
  border: '1px solid amberBorder',
}

export const StatusActive = {
  extends: 'StatusChip',
  background: 'greenBg',
  color: 'green',
  border: '1px solid greenBorder',
}

export const StatusClosed = {
  extends: 'StatusChip',
  background: 'surfaceBorder',
  color: 'textMuted',
  border: '1px solid surfaceBorderStrong',
}
